import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Loading fallback component for lazy-loaded admin pages.
 * Displays a centered spinner with optional loading message.
 *
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message to display
 */
const AdminLoadingFallback = ({ message = 'Loading admin panel...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress
        size={48}
        thickness={4}
        sx={{
          color: 'primary.main',
        }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 1 }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default AdminLoadingFallback;
